import SubscribeToNewsLetterButton from "%/dynamic-component-editor/standard-components/subscribe-to-newsletter/elements/SubscribeToNewsLetterButton.vue";
import SubscribeToNewsLetterInput from "%/dynamic-component-editor/standard-components/subscribe-to-newsletter/elements/SubscribeToNewsLetterInput.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyNewsletter extends LegacyEntity {
  get elements() {
    return {
      SubscribeToNewsLetterButton,
      SubscribeToNewsLetterInput,
    };
  }
}
